import { useUserRoles } from 'src/features/auth/useUserRoles';

import { rolesThatCanCreateTripsInThePast } from './rolesThatCanCreateTripsInThePast';

export function useCanCreateTripInThePast() {
  const { role } = useUserRoles();
  return role && rolesThatCanCreateTripsInThePast.includes(role);
}
